import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/catalogo-de-concepto-periodicidad-de-seguridad-social/';
/**
 * GET Periodicidad De Seguridad Sociales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodicidadDeSeguridadSociales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodicidad De Seguridad Social
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodicidadDeSeguridadSocial = async (id) => {
  try {
    const response = await API.get(`${baseURI} ${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodicidad De Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodicidadDeSeguridadSocial = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodicidad De Seguridad Social
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodicidadDeSeguridadSocial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI} ${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE UMA General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodicidadDeSeguridadSocial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
